<div class="MainForm">
	<h4>Main Details:</h4>

	<!--Main Details-->
	<div class="Grid2Col">
		<label>Staff Member:</label>
		<label>{{ PersonName }}</label>

		<label>Scan Date:</label>
		<label>{{ ScanDateDesc }}</label>

		<label>Log Date:</label>
		<label>{{ LogDTDesc }}</label>

		<label>Station Mode:</label>
		<label>{{ StationMode }}</label>

		<label>Scan Result:</label>
		<label>{{ ResultDesc }}</label>

		<label>Scan Station:</label>
		<label>{{ ScanStation }}</label>

		<label>Facility:</label>
		<label>{{ FacilityDesc }}</label>

		<label>Location:</label>
		<label>{{ LocationDesc }}</label>
	</div>
</div>

<!--Entry-->

<!--Exit-->
<div class="MainForm TopMargin" *ngIf="StationModeID == 2">
	<h4>Exit Details:</h4>

	<div class="Grid2Col">
		<label>Release Type:</label>
		<label>{{ ReleaseType }}</label>
	</div>
</div>

<!--Access-->
<div class="MainForm TopMargin" *ngIf="StationModeID == 4">
	<h4>Access Details:</h4>

	<div class="Grid2Col">
		<label>Course:</label>
		<label>{{ CourseType }}</label>

		<label>Section:</label>
		<label>{{ Section }}</label>

		<label>Room Number:</label>
		<label>{{ RoomNo }}</label>
	</div>
</div>

<!--Meal-->
<div class="MainForm TopMargin" *ngIf="StationModeID == 3">
	<h4>Meal Details:</h4>

	<div class="Grid2Col">
		<label>Meal:</label>
		<label>{{ MealName }}</label>

		<label>Subsidy Type:</label>
		<label>{{ MealSubsidyTypeDesc }}</label>
	</div>
</div>

<!--TimeStamp-->
<div class="MainForm TopMargin" *ngIf="StationModeID == 5">
	<h4>Time Stamp Details:</h4>

	<div class="Grid2Col">
		<label>Time Scan Type:</label>
		<label>{{ TimeScanType }}</label>
	</div>
</div>

<!--Event-->
<div class="MainForm TopMargin" *ngIf="StationModeID == 6">
	<h4>Event Details:</h4>

	<div class="Grid2Col">
		<label>Event Name:</label>
		<label>{{ EventName }}</label>
	</div>
</div>

<div class="MainForm TopMargin" *ngIf="IsManual() == true">
	<h4>Manual Details:</h4>

	<div class="Grid2Col">
		<label>ID Status</label>
		<label>{{ IDStatus }}</label>

		<label>Reprint Card</label>
		<label>{{ ReprintCard }}</label>

		<label>Printed Temp Card</label>
		<label>{{ PrintedTempCard }}</label>

		<label>Charged Reprint Fee</label>
		<label>{{ ChargedReprintFee }}</label>

		<label>Charged Temp Fee</label>
		<label>{{ ChargedTempFee }}</label>

		<label>Paid Amount</label>
		<label>${{ PaidAmount }}</label>

		<label>Reprint Fee</label>
		<label>${{ ReprintFee }}</label>

		<label>TempID Fee</label>
		<label>${{ TempIDFee }}</label>

		<label>Comments</label>
		<label>{{ Comments }}</label>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
